export default __webpack_public_path__ + "static/media/details.fdff3f7a.png";